module.exports = __webpack_public_path__ + "static/img/默认@3x.82cb0cb0.jpg";